<template>
  <user-dashboard
    :autoRefresh="true"
    :table-stats="tableStats"
    :table-fields="['med_name']">
  </user-dashboard>
</template>

<script>
    import UserDashboard from '@/components/UserDashboard'

    export default {
        name: 'DashboardPublisher',
        data() {
            return {
                tableStats: ['auctions', 'bids', 'bid_rate', 'clears', 'clear_rate', 'cost']
            }
        },
        components: {
            UserDashboard
        }
    }
</script>



// WEBPACK FOOTER //
// src/publisher/pages/Dashboard.vue